<template>
  <div class="traffic">
    <div class="traffic-logo">
      <img :src="logo" alt="">
    </div>

    <div class="traffic-entry">
      <div class="entry-item" @click="toDetail('entry_1')">
        <div class="title">世纪城布撤展交通</div>
        <div class="title">车证办理指南</div>
        <div class="time-wrap">
          <div class="time-1">布展日期：3月21-24日</div>
          <div class="time-1">撤展日期：3月28日</div>
          <div class="time-1">开展日期：3月25-27日</div>
        </div>
        <div class="arrow">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/arrow.png" alt="">
        </div>
        <div class="icon-image">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/traffic_icon.png" alt="">
        </div>
      </div>
      <div class="entry-item" @click="toDetail('entry_2')">
        <div class="title">西博城布撤展交通</div>
        <div class="title">车证办理指南</div>

        <div class="time-wrap">
          <div class="time-1">布展日期：3月21-24日</div>
          <div class="time-1">撤展日期：3月28日</div>
          <div class="time-1">开展日期：3月25-27日</div>
        </div>
        <div class="arrow">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/arrow.png" alt="">
        </div>
        <div class="icon-image">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/traffic_icon.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const time = Date.now()
      return {
        logo: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/traffic/traffic-logo.png?_t=" + time,
      }
    },
    methods: {
      toDetail(entry) {
        if (entry === 'entry_1') {
          this.$router.push({
            path: '/traffic-shiji'
          })
        } else {
          this.$router.push({
            path: '/traffic-xibo'
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .traffic {
    width: 100%;
    padding-top: 20px;
  }
  .traffic-logo {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 221px;
      height: 84px;
      display: block;
    }
  }
  .traffic-entry {
    padding: 20px 16px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .entry-item {
    width: 100%;
    background: #FF1EA0;
    border-radius: 4px;
    padding-top: 20px;
    .title {
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
    }
    .time-wrap {
      margin-top: 32px;
      height: 50px;
    }
    .time-1 {
      font-weight: 400;
      font-size: 13px;
      color: #FFFFFF;
      text-align: left;
      padding-left: 20px;
      box-sizing: border-box;
    }
    .time-2 {
      font-weight: 400;
      font-size: 13px;
      color: #FFFFFF;
      text-align: center;
      margin-top: 2px;
    }
    .arrow {
      width: 24px;
      height: 24px;
      margin: 17px auto 0;
      img {
        width: 100%;
        display: block;
      }
    }
    .icon-image {
      margin-top: 17px;
      display: flex;
      flex-direction: row-reverse;
      img {
        width: 50px;
        height: 50px;
        display: inline-block;
      }
    }
  }
</style>